import Work1 from "../../assets/textanalyzer.png";
import Work2 from "../../assets/portfolio-work.png";
import Work3 from "../../assets/work-3.svg";

const Menu = [
    {
        id: 1,
        image: Work1,
        title: "Text Analyzer",
        category: ["Frontend", "React"],
        url: "https://textanalyzerbysd.vercel.app/",
        repositoryUrl: "https://github.com/subimaldas/TextEditor"
    },
    {
        id: 2,
        image: Work2,
        title: "Portfolio",
        category: ["Frontend", "React"],
        url: "https://portfolio-work.vercel.app/",
        repositoryUrl: "https://github.com/subimaldas/portfolio-work"
    },
    {
        id: 3,
        image: Work3,
        title: "Travel Advisor",
        category: ["Frontend"],
        url: "",
        repositoryUrl: ""
    }
];

export default Menu;
